import React, { FunctionComponent, useEffect, useState } from 'react';
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native';
import { connect } from 'react-redux';
import { IAppStore, Orientation } from '../reducer';
import { orientationSelector } from '../selectors';

interface IProps {
  orientation: Orientation;
  containerStyle?: StyleProp<ViewStyle>;
  rowStyle?: StyleProp<ViewStyle>;
  colStyle?: StyleProp<ViewStyle>;
}

enum layoutType {
  row = 'row',
  col = 'col',
}

const ResponsiveLayout: FunctionComponent<IProps> = ({
  orientation,
  containerStyle,
  children,
  rowStyle,
  colStyle,
}) => {
  const [direction, setDirection] = useState<layoutType>(layoutType.col);
  useEffect(() => {
    if (orientation === 'PORTRAIT') {
      setDirection(layoutType.col);
    } else {
      setDirection(layoutType.row);
    }
  }, [orientation]);

  const directionStyle = direction === layoutType.col
    ? [styles[layoutType.col], colStyle]
    : [styles[layoutType.row], rowStyle];

  return (
    <View style={[
      styles.container,
      directionStyle,
      containerStyle,
    ]}>
      {children}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  [layoutType.col]: {
    flexDirection: 'column',
  },
  [layoutType.row]: {
    flexWrap: 'wrap',
    flexDirection: 'row',
  },
});

const mapStateToProps = (state: IAppStore): Partial<IProps> => ({
  orientation: orientationSelector(state),
});

export const HomeWorkoutResponsiveLayout = connect(mapStateToProps)(ResponsiveLayout);
